const _jsxFileName = "/codebuild/output/src3182596400/src/codeconnections.ap-southeast-1.amazonaws.com/git-http/178309656639/ap-southeast-1/c294c899-f583-4463-ab85-039718732de9/suphachai2/mobileschool/ms-shared/src/components/archives/user_manual.jsx";import React, { Component }  from 'react'

class UserManual extends Component {
    render() {
        return (
            React.createElement(React.Fragment, null
                , React.createElement('embed', { src: "/shared/test.pdf", type: "application/pdf", width: "100%", height: "800px", __self: this, __source: {fileName: _jsxFileName, lineNumber: 7}} )
            )
        )
    }
}

export default UserManual;